type DeepObject = { [key: string]: any };

function toCamelCaseKey(key: string): string {
  if (key === 'ID') {
    return 'id';
  }

  const normalizedKey = key
    .replace(/([A-Z]+)([A-Z][a-z])/g, '$1 $2')
    .replace(/([a-z0-9])([A-Z])/g, '$1 $2')
    .replace(/[\W_]+/g, ' ')
    .trim();

  if (!normalizedKey) {
    return key.toLowerCase();
  }

  return normalizedKey
    .split(/\s+/)
    .map((word, index) => {
      const lowercaseWord = word.toLowerCase();
      return index === 0
        ? lowercaseWord
        : lowercaseWord.charAt(0).toUpperCase() + lowercaseWord.slice(1);
    })
    .join('');
}

export function convertKeysToCamelCase<T extends DeepObject>(obj: T): DeepObject {
  // Handle null/undefined
  if (obj === null || typeof obj !== 'object') {
    return obj;
  }

  // Handle arrays
  if (Array.isArray(obj)) {
    return obj.map(item => convertKeysToCamelCase(item));
  }

  return Object.entries(obj).reduce((acc, [key, value]) => {
    const camelKey = toCamelCaseKey(key);

    // Recursively convert nested objects
    const newValue = typeof value === 'object' ? convertKeysToCamelCase(value) : value;

    return {
      ...acc,
      [camelKey]: newValue
    };
  }, {});
}